<template>
	<div class="comp-chat-empty">
		<div class="comp-chat-empty-wrap">
			<div class="comp-chat-empty-img">
				
			</div>
			<div class="comp-chat-empty-text">
				<p>{{showText}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'ChatEmpty',
		data(){
			return {
				
			}
		},
		props:{
			showText: {
				type: String,
				default: '请选择聊天对象'
			}
		}
	}
</script>

<style>
	.comp-chat-empty{
		position: relative;
		width: 100%;
		height: 100%;
		background-color: #ffffff;
		overflow: hidden;
		color: #999999;
	}
	.comp-chat-empty .comp-chat-empty-wrap{
		position: absolute;
		top: 50%;
		width: 100%;
		height: auto;
		transform: translateY(-100%);
	}
	.comp-chat-empty-wrap .comp-chat-empty-img{
		width: 128px;
		height: 128px;
		margin-top: 100px;
		margin: 0 auto;
		background-image: url(../assets/img/chat-big.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.comp-chat-empty-wrap .comp-chat-empty-text{
		width: 100%;
		height: 50px;
		line-height: 50px;
		margin-top: 10px;
		text-align: center;
	}
</style>
